/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreNotificationOff = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M10.989 13.25H6.101c.246 1.111 1.282 2 2.444 2 1.161 0 2.198-.889 2.444-2zm1.764-8.088L5.081 12.25h8.464a.5.5 0 0 0 .37-.836l-.87-.957V6.75c0-.559-.104-1.094-.292-1.588zm2.192-4.059a.497.497 0 0 0-.706-.028l-2.625 2.424a4.442 4.442 0 0 0-2.276-1.168.982.982 0 0 0 .207-.581 1 1 0 0 0-2 0c0 .221.086.415.207.581-2.103.376-3.707 2.209-3.707 4.419v3.707l-.203.224-2.759 2.549a.5.5 0 1 0 .679.734L14.917 1.809a.5.5 0 0 0 .028-.706z"
    />
  </svg>
);

IconCoreNotificationOff.displayName = 'IconCoreNotificationOff';

IconCoreNotificationOff.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreNotificationOff);
IconCoreNotificationOff.displayName = 'IconCoreNotificationOff';
